<template>
  <div class="toast">
    <p>{{ content }}</p>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  mounted() {
    setTimeout(() => {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
      typeof this.callback === 'function' && this.callback()
    }, this.duration)
  },
  data() {
    return {
      content: '',
      duration: 2500,
      callback: () => {},
    }
  },
}
</script>

<style lang="scss" scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  color: #fff;
  z-index: 9999;
  background: transparent;
  pointer-events: none;
  min-height: 88px;
  > p {
    padding: 16px 32px;
    text-align: center;
    min-width: 209px;
    font-size: 26px;
    line-height: 1.5;
    border-radius: 10px;
    background: rgba(0,0,0,0.7);
    animation: fade 3000 ease;
  }
}
@keyframes fade {
  0% {
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  60% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
